import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { StyleSheet, View, Text, TouchableOpacity, Image, } from "react-native";
// import Checkbox from 'expo-checkbox';
import { useHistory } from "react-router-dom";
// import useAuthentication from "../../../hooks/useAuthentication";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedStores } from "../redux/reducers/stores.reducer";
import { Typography, Checkbox, Grid } from "@mui/material";
import firebase from "../utils/firebase";
const StoreCard = ({ store, handleAllCheck }) => {
  const { t, i18n } = useTranslation();
  // const { userInfo, updateUserInfo, isAnonymous } = useAuthentication();
  const userInfo = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const navigate = useHistory();
  const selectedStores = useSelector((state) => state.stores.selectedStores);
  const isAllStoresSelected = useSelector((state) => state.stores.isAll);

  const updateUserInfo = async (updatedUser) => {
    firebase
      .firestore()
      .collection("users")
      .doc(userInfo.id)
      .set({ ...updatedUser })
      .then((userInfo) => {
        dispatch(updatedUser());
        console.log("success");
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (
      store &&
      selectedStores &&
      selectedStores.length > 0 &&
      store.id &&
      selectedStores.includes(store.id)
    ) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [selectedStores]);

  const handleStorePress = () => {
    if (!!store.id) {
      navigate.push("/store/"+store.id);
    }
  };

  const handlePress = async () => {
    if (!store) {
      if (isAllStoresSelected) {
        if (handleAllCheck) {
          handleAllCheck(false);
        }
      } else {
        if (handleAllCheck) {
          handleAllCheck(true);
        }
      }
    } else {
      handleCheck(
        userInfo & selectedStores ? !selectedStores.includes(store.id) : false
      );
    }
  };
  const handleCheck = async (checked) => {
    if (!store) {
      if (handleAllCheck) {
        handleAllCheck(checked);
      }
    } else {
      setChecked(checked);
      if (checked && userInfo && !selectedStores) {
        setLoading(true);
        const updatedStores = selectedStores
          ? [...selectedStores, store.id]
          : [store.id];
        dispatch(setSelectedStores(updatedStores));
        if (!userInfo?.isAnonymous) {
          await updateUserInfo({ ...userInfo, stores: updatedStores });
        }
        setLoading(false);
      }
      if (
        userInfo &&
        selectedStores &&
        checked &&
        store.id &&
        !selectedStores.includes(store.id)
      ) {
        setLoading(true);
        const updatedStores = selectedStores
          ? [...selectedStores, store.id]
          : [store.id];
        dispatch(setSelectedStores(updatedStores));
        if (!userInfo?.isAnonymous) {
          await updateUserInfo({ ...userInfo, stores: updatedStores });
        }
        setLoading(false);
      } else if (
        userInfo &&
        !checked &&
        selectedStores &&
        store.id &&
        selectedStores.includes(store.id)
      ) {
        setLoading(true);
        const updatedStores = selectedStores
          ? selectedStores.filter((item) => item != store.id)
          : [];
        dispatch(setSelectedStores(updatedStores));
        if (!userInfo?.isAnonymous) {
          await updateUserInfo({ ...userInfo, stores: updatedStores });
        }
        setLoading(false);
      }
    }
    // updateUserInfo({ ...userInfo, stores: selectedStores })
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent={"center"}
        style={{
          backgroundColor: "#fafafa",
          display: "flex",
          paddingTop: 10,
          paddingBottom: 10,
          borderRadius: 10,
          marginBottom: 30,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "90%",
          borderStyle: "solid",
          opacity: 1,
          borderWidth: 0.35,
          borderColor: "#fac904",
          marginLeft: "3px",
        }}
      >
        <Grid
          item
          xs={10}
          lg={10}
          sm={10}
          md={10}
          key={store ? store.id : "all Stores card"}
          // disabled={loading || !store}
          onClick={handleStorePress}
          style={{ flexDirection: "row", alignSelf: "flex-start" }}
        >
          <div
            style={{
              alignSelf: "center",
              paddingLeft: 10,
              paddingRight: 10,
              left: 10,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {store && !!store.image && store.image !== "" && (
              <img
                src={store.image}
                alt=""
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 100,
                  marginRight: 15,
                  alignSelf: "center",
                }}
              />
            )}
            {!store && (
              <Typography
                style={{
                  fontSize: 18,
                  fontWeight: "500",
                  textAlignVertical: "center",
                }}
              >
                {t("stores.all")}
              </Typography>
            )}
            {store && (
              <Typography
                style={{
                  fontSize: 18,
                  fontWeight: "500",
                  textAlignVertical: "center",
                }}
              >{`${
                i18n.language === "ar" ? store.nameAr : store.nameEn
              }`}</Typography>
            )}
            {store && (!!store.branchAr || !!store.branchEn ||!!store.branch) && (
              <Typography style={{ fontSize: 13, marginTop: 5 , paddingInline: 10 }}>{`${
                i18n.language === "ar" &&!!store.branchAr
                  ? store.branchAr 
                  : !!store.branchEn ?store.branchEn: !!store.branch?store.branch:""
              }`}</Typography>
            )}
          </div>
        </Grid>
        <Grid
          item
          xs={2}
          lg={2}
          sm={2}
          md={2}
          style={{
            display: "flex",
            flexDirection: "row",
            alignSelf: "flex-end",
            alignItems: "center",
            justifyContent: "center",
          }}

          className="ccchc"
        >
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 30 } }}
            checked={isChecked || isAllStoresSelected}
            disabled={loading}
            style={{
              alignSelf: "center",
              backgroundColor: "#fafafa",
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 6,
              paddingRight: 6,
              display: "flex",
              right: 0,
              flexDirection: "column",
              opacity: 1,
            }}
            onChange={(ev) => {
              handleCheck(ev.target.checked);
            }}
            // color={customTheme.light.primary}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default StoreCard;
